module.exports = __webpack_public_path__ + "img/a8_08.14b34b81.jpg";